export const SAVE_HEIGHT_NOTICEBAR_CONFIRM_EMAIL = 'SAVE_HEIGHT_NOTICEBAR_CONFIRM_EMAIL';

export const saveHeightNoticebarConfirmEmail = (newState) => ({
  type: SAVE_HEIGHT_NOTICEBAR_CONFIRM_EMAIL,
  payload: newState,
});
